import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.143 3.486a1 1 0 0 1 1.714 0l9 15a1 1 0 0 1 -.857 1.514h-18a1 1 0 0 1 -.857 -1.514z","key":"svg-0"}]]

/**
 * IconBrandVercelFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItYnJhbmQtdmVyY2VsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMS4xNDMgMy40ODZhMSAxIDAgMCAxIDEuNzE0IDBsOSAxNWExIDEgMCAwIDEgLS44NTcgMS41MTRoLTE4YTEgMSAwIDAgMSAtLjg1NyAtMS41MTR6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-vercel-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandVercelFilled = createReactComponent('filled', 'brand-vercel-filled', 'BrandVercelFilled', __iconNode);

export default IconBrandVercelFilled;